import { render, staticRenderFns } from "./LearningGroupNew.vue?vue&type=template&id=860438f0&"
import script from "./LearningGroupNew.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports